<template>
  <div id="app">
    <keep-alive :include="keepAlive">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
// import Vue from 'vue';
// import CommonFooter from '@/components/common/footer';
// import { Tabbar, TabbarItem } from 'vant';

// Vue.use(Tabbar);
// Vue.use(TabbarItem);
export default {
  components: {
    // CommonFooter
  },
  computed: {
    keepAlive() {
      return this.$store.state.keepAlive.keepAlive
    },
    getCanShow() {
      return this.$route.name ? this.$route.name.indexOf("Error") < 0 : false
    }
  },
  methods: {

  },
}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

.page{
  padding: 20px;
}
</style>
